Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:bool-param-default
var _virtualConsole;
var _isUseVirtualConsole = true;
exports.useVirtualConsole = function (state) {
    _isUseVirtualConsole = state;
};
exports.getVirtualConsole = function (logger) {
    if (!_isUseVirtualConsole) {
        return console;
    }
    var Log4JConsole = /** @class */ (function () {
        function Log4JConsole() {
            this.isVirtual = true;
            this.memory = {};
        }
        Log4JConsole.prototype.assert = function (condition, message) {
            var data = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                data[_i - 2] = arguments[_i];
            }
            _virtualConsole.assert.call(arguments);
        };
        Log4JConsole.prototype.clear = function () {
            _virtualConsole.clear();
        };
        Log4JConsole.prototype.count = function (label) {
            _virtualConsole.count(label);
        };
        Log4JConsole.prototype.dir = function (value) {
            var optionalParams = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                optionalParams[_i - 1] = arguments[_i];
            }
            _virtualConsole.dir.apply(_virtualConsole, [value].concat(optionalParams));
        };
        Log4JConsole.prototype.dirxml = function (value) {
            _virtualConsole.dirxml(value);
        };
        Log4JConsole.prototype.group = function (groupTitle) {
            var optionalParams = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                optionalParams[_i - 1] = arguments[_i];
            }
            _virtualConsole.group.apply(_virtualConsole, [groupTitle].concat(optionalParams));
        };
        Log4JConsole.prototype.groupCollapsed = function (groupTitle) {
            var optionalParams = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                optionalParams[_i - 1] = arguments[_i];
            }
            _virtualConsole.groupCollapsed.apply(_virtualConsole, [groupTitle].concat(optionalParams));
        };
        Log4JConsole.prototype.groupEnd = function () {
            _virtualConsole.groupEnd();
        };
        Log4JConsole.prototype.markTimeline = function (label) {
            if (typeof _virtualConsole.markTimeline === 'function') {
                _virtualConsole.markTimeline(label);
            }
        };
        Log4JConsole.prototype.msIsIndependentlyComposed = function (element) {
            if (typeof _virtualConsole.msIsIndependentlyComposed === 'function') {
                return _virtualConsole.msIsIndependentlyComposed(element);
            }
        };
        Log4JConsole.prototype.profile = function (reportName) {
            if (typeof _virtualConsole.profile === 'function') {
                _virtualConsole.profile(reportName);
            }
        };
        Log4JConsole.prototype.profileEnd = function () {
            if (typeof _virtualConsole.profileEnd === 'function') {
                _virtualConsole.profileEnd();
            }
        };
        Log4JConsole.prototype.table = function () {
            var tabularData = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                tabularData[_i] = arguments[_i];
            }
            _virtualConsole.table.apply(_virtualConsole, tabularData);
        };
        Log4JConsole.prototype.time = function (label) {
            _virtualConsole.time(label);
        };
        Log4JConsole.prototype.timeEnd = function (label) {
            if (typeof _virtualConsole.timeEnd === 'function') {
                _virtualConsole.timeEnd(label);
            }
        };
        Log4JConsole.prototype.timeStamp = function (label) {
            if (typeof _virtualConsole.timeStamp === 'function') {
                _virtualConsole.timeStamp(label);
            }
        };
        Log4JConsole.prototype.timeline = function (label) {
            if (typeof _virtualConsole.timeline === 'function') {
                _virtualConsole.timeline(label);
            }
        };
        Log4JConsole.prototype.timelineEnd = function (label) {
            if (typeof _virtualConsole.timelineEnd === 'function') {
                _virtualConsole.timelineEnd(label);
            }
        };
        Log4JConsole.prototype.debug = function (message) {
            var optionalParams = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                optionalParams[_i - 1] = arguments[_i];
            }
            logger.debug.apply(logger, [message].concat(optionalParams));
        };
        Log4JConsole.prototype.error = function (message) {
            var optionalParams = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                optionalParams[_i - 1] = arguments[_i];
            }
            logger.error.apply(logger, [message].concat(optionalParams));
        };
        Log4JConsole.prototype.exception = function (message) {
            var optionalParams = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                optionalParams[_i - 1] = arguments[_i];
            }
            logger.error.apply(logger, [message].concat(optionalParams));
        };
        Log4JConsole.prototype.info = function (message) {
            var optionalParams = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                optionalParams[_i - 1] = arguments[_i];
            }
            logger.info.apply(logger, [message].concat(optionalParams));
        };
        Log4JConsole.prototype.log = function (message) {
            var optionalParams = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                optionalParams[_i - 1] = arguments[_i];
            }
            logger.debug.apply(logger, [message].concat(optionalParams));
        };
        Log4JConsole.prototype.trace = function (message) {
            var optionalParams = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                optionalParams[_i - 1] = arguments[_i];
            }
            logger.trace.apply(logger, [message].concat(optionalParams));
        };
        Log4JConsole.prototype.warn = function (message) {
            var optionalParams = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                optionalParams[_i - 1] = arguments[_i];
            }
            logger.warn.apply(logger, [message].concat(optionalParams));
        };
        Log4JConsole.prototype.countReset = function (label) {
            _virtualConsole.countReset(label);
        };
        Log4JConsole.prototype.timeLog = function (label) {
            var data = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                data[_i - 1] = arguments[_i];
            }
            _virtualConsole.timeLog.apply(_virtualConsole, [label].concat(data));
        };
        return Log4JConsole;
    }());
    if (!_virtualConsole) {
        _virtualConsole = console;
        console = new Log4JConsole();
    }
    return _virtualConsole;
};
